import { messageQuickActionQueryKeys as e } from "./useMessageQuickActionQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { messageAutomationsApi as r } from "@maat/api-chat";
//#region src/messageQuickActions/useRemoveMessageQuickActionMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ templateKey: e, listingId: t }) => r.removeQuickAction(e, t),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.list(n.listingId) });
		}
	});
};
//#endregion
export { i as useRemoveMessageQuickActionMutation };
